module.exports = __webpack_public_path__ + "static/img/downloadBtn.e912489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/role/downloadBtn.png
// module id = WwgV
// module chunks = 0